<template>
  <div>
    <bv-top></bv-top>
    <van-list
        v-show="!noResultShow"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onListLoad"
        :immediate-check="false"
    >

      <van-cell v-for="item in list">
        <van-row>
          <van-col span="18" @click="toBranchInfo(item)">
            <div style="text-align: left;font-size: 18px">
              {{item.shortAddress}}
            </div>
            <div style="text-align: left;font-size: 13px;color: #969799">
              {{item.branchName}}
            </div>
          </van-col>
          <van-col span="2">
            <van-icon name="phone-o" color="#e8a010" size="1.5rem" />
          </van-col>
          <van-col span="1">
          </van-col>
          <van-col span="1">
            <van-icon @click="gaode(item)" name="location" color="#128ee8" size="1.5rem" />
          </van-col>
        </van-row>
      </van-cell>
    </van-list>

    <van-empty v-show="noResultShow" description="没有更多内容"/>
  </div>
</template>

<script>

import Top from '@/views/components/Top'
import {fetchBranch} from '@/api/public/branch'

export default {
  name: 'BranchList',
  components: {
    BvTop: Top
  },
  data() {
    return {
      smallLogo: require('@/assets/small-logo.png'),
      noResult: require('@/assets/empty.png'),
      label: decodeURIComponent(this.$route.query.label),
      value: this.$route.query.value,
      noResultShow: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNo: 0,
        limit: 10
      }
    }
  },
  methods: {
    toMaintainFund() {
      this.$router.push('/maintainFund')
    },
    toBranchInfo(item) {
      this.$router.push({
        path: '/public/branchInfo',
        query: {value: this.value,
          label: this.label,
          item: item
        }
      });
    },
    onListLoad() {

      setTimeout(() => {
        this.pageParam.pageNo = this.pageParam.pageNo + 1;
        let params = {
          page: this.pageParam.pageNo,
          limit: this.pageParam.limit
        };
        fetchBranch(params).then(res => {
          this.list = this.list.concat(res.data.list);

          if (res.data.total === 0) { // 查无数据
            this.noResultShow = true
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (res.data.isLastPage) {
            this.finished = true;
          }
        }).catch(() => {
          this.error = true;
        });
      }, 500);
    },
    gaode(item){
      let lng = item.lng
      let lat = item.lat
      let partnerAddress = item.shortAddress
      console.log(item)
      window.location.href = "https://uri.amap.com/marker?position=" + lng + "," + lat +
          "&name=" + partnerAddress;
    }
  },
  mounted() {
    this.onListLoad()
  }
}
</script>
<style>

</style>
